import React from 'react';

const Footer = () => (
  <footer>
    <div className='content space-between flex-v-center'>
      <div className='footer-inner-left'>
        <p>
          {new Date().getFullYear()}
          &nbsp;ConnectHealthPro. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
